<template>
<BootstrapDialog title="设置状态" ref="dialog" size="lg" @afterClose="afterClose()">
	<template v-slot:body>
		<div class="modal-body wrapper-lg" style="width:100%">
		    <div class="row">
		        <div class="col-sm-8 col-sm-offset-2">
		            <h3 class="m-t-none m-b font-thin"><i class="fa fa-pencil-square-o" aria-hidden="true"></i>批量设置状态</h3>
		            <form role="form" style="margin-top: 20px" id="user_add_form">
		                <div class="form-group">
		                    <label>状态</label>
		                        <select name="stzt" v-model="model.zt" class="form-control" v-validate="{required:true,max:50}" data-vv-as="试题状态">
		                            <option value="">请选择</option>
		                            <option v-for="stzt in stztList" :key="stzt.value" :value="stzt.value">{{stzt.text}}</option>
		                        </select>
		                    <span class="error_validate_msg"><em>{{ errors.first('stzt') }}</em></span>
		                </div>
		            </form>
		        </div>
		    </div>
		</div>
	</template>
	<template v-slot:footer>
		<button class="btn btn-primary" type="button" @click="confirm()">确定</button>
		<button style="margin-left:10px" class="btn btn-default" type="button" @click="close()" >关闭</button>
	</template>
</BootstrapDialog>
</template>
<script>

    /**
     * 批量设置状态
     */
    export default {
        name:'QuesBatchSetZt',
        components:{
        },
        data:function(){
            return {
                stztList:[],//试题状态
                model:{
                    ids:'',
                    zt:'',
                }
            }
        },
        methods:{
			reset:function(){
				this.stztList = [];//试题状态
				this.model = {
				    ids:'',
				    zt:''
				}
			},
			open:function(params){
				this.stztList = [{value: 'OK', text: '开放'}, {value: 'BLOCK', text: '关闭'}];//试题状态
				this.model.ids = params.ids;
				this.$refs.dialog.open();
			},
			close:function(){
				this.$refs.dialog.close();
			},	
			afterClose:function(){
				this.$validator.reset();
				this.reset();
			},
            confirm:function(){
                this.$validator.validateAll().then((result) => {
                    if (result) {//如果表单校验通过才可以保存
                        this.$http.post('/htgl/zktk/st/szzt',this.model).then(res=>{
                            if(res.data==true){
								this.$success('操作成功',()=>{
									this.close();
									this.$parent.load();//刷新列表
								});
                            }
                        });
                    }
                });
            }
        }
    }
</script>